/**
 * Wo eine Community (intern: Space) öffentlich liegt — an EINER Stelle.
 *
 *   /community/<slug>         die Community (Landing für Gäste, Bereich für Mitglieder)
 *   /community/<slug>/about   dieselbe Seite, Mitglieder starten auf „About"
 *   /communities              die Übersicht
 *
 * Bis zum 13.09.2026 hießen die Adressen /spaces/<slug>, /spaces/<slug>/about
 * und /spaces/discover. „Space" ist unser interner Begriff; nach außen heißt es
 * Community.
 *
 * DIE ALTEN ADRESSEN BLEIBEN GÜLTIG, auf drei Wegen:
 *   - Browser: der Server leitet dauerhaft (301) um, Abfrageparameter inklusive
 *     — ?ref=<code> trägt die Affiliate-Zuordnung und darf nicht verloren gehen
 *     (server/routes/community-redirects.routes.ts)
 *   - Navigation innerhalb der Anwendung: dieselbe Umleitung im Router (App.tsx)
 *   - Expo-App: iOS öffnet die App anhand von apple-app-site-association, Android
 *     anhand der intentFilters — dort stehen BEIDE Pfade, und App.tsx in der App
 *     erkennt beide. Eine Umleitung des Servers kommt dort gar nicht erst zum
 *     Zug: das Betriebssystem entscheidet vor dem ersten Byte.
 *
 * Reines TypeScript ohne React und DOM: Server, Web-Anwendung und Expo-App
 * importieren diese Datei (die App über @shared/, siehe metro.config.js).
 */
export const COMMUNITY_PREFIX = '/community';
export const COMMUNITIES_UEBERSICHT = '/communities';

/** Die Community; mit `about` die Variante, die Mitglieder auf „About" starten lässt. */
export function communityPfad(slugOderId: string, teil?: 'about'): string {
  return `${COMMUNITY_PREFIX}/${encodeURIComponent(slugOderId)}${teil ? `/${teil}` : ''}`;
}

/**
 * Erkennt eine Community-Adresse — alt oder neu — und liefert den Slug.
 * Für Deep Links in der App: dort kommen beide Formen an, solange alte Links
 * im Umlauf sind (und das ist: für immer).
 */
export function communitySlugAusUrl(url: string): string | null {
  const m = url.match(/\/(?:community|spaces)\/([^/?#]+)/);
  if (!m || !m[1]) return null;
  const slug = decodeURIComponent(m[1]);
  // /spaces/discover war die Übersicht, keine Community.
  return slug === 'discover' ? null : slug;
}
